import { MenuMode } from '@app/engine/core/interfaces';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { errorManagerInstance } from '@app/engine/utils/errorManager';
import videocamPng from '@public/img/icons/videocam.png';
import { KeepTrackPlugin } from '../../engine/plugins/base-plugin';
import { StreamManager } from './stream-manager';
import { EventBus } from '@app/engine/events/event-bus';
export class ScreenRecorder extends KeepTrackPlugin {
    id = 'ScreenRecorder';
    dependencies_ = [];
    static FILE_NAME = 'keeptrack.webm';
    bottomIconCallback = () => {
        if (this.isCompatibilityIssue_) {
            errorManagerInstance.warn('Recording unavailable due to compatibility issues!');
            this.shakeBottomIcon();
            return;
        }
        if (this.streamManagerInstance_.isVideoRecording) {
            this.streamManagerInstance_.stop();
        }
        else {
            try {
                this.setBottomIconToSelected();
                this.streamManagerInstance_.start();
                this.streamManagerInstance_.isVideoRecording = true;
            }
            catch {
                errorManagerInstance.warn('Compatibility Error with Recording!');
                this.streamManagerInstance_.isVideoRecording = false;
                this.setBottomIconToDisabled();
                this.shakeBottomIcon();
                this.isCompatibilityIssue_ = true;
            }
        }
    };
    menuMode = [MenuMode.ADVANCED, MenuMode.ALL];
    bottomIconImg = videocamPng;
    isCompatibilityIssue_ = false;
    streamManagerInstance_;
    addJs() {
        super.addJs();
        EventBus.getInstance().on(EventBusEvent.uiManagerOnReady, () => {
            try {
                this.streamManagerInstance_ = new StreamManager(settingsManager.videoBitsPerSecond, this.onStop_.bind(this), this.onMinorError_.bind(this), this.onError_.bind(this));
            }
            catch (e) {
                errorManagerInstance.warn(`Compatibility Error with Recording: ${e}`);
            }
        });
    }
    getRecorderObject() {
        return this.streamManagerInstance_;
    }
    onError_() {
        this.setBottomIconToDisabled();
        this.isIconDisabled = true;
        this.streamManagerInstance_.isVideoRecording = false;
        this.shakeBottomIcon();
        this.isCompatibilityIssue_ = true;
    }
    onMinorError_() {
        this.setBottomIconToUnselected();
    }
    onStop_() {
        this.streamManagerInstance_.save(ScreenRecorder.FILE_NAME);
        this.setBottomIconToUnselected();
    }
}
